const translations = {
  searchOnMap: 'Search on map',
  useCompleteSearch: 'Use complete search',
  selectUsers: 'User selection',
  'filters.creation': 'Creation'
}

export default translations
